import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { brands } from '../../data/brands';

export default function BrandSearch() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [filteredBrands, setFilteredBrands] = useState(brands);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Filter brands based on search input
  useEffect(() => {
    const filtered = brands.filter(brand =>
      brand.name.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredBrands(filtered);
    setIsOpen(search.length > 0);
  }, [search]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleBrandSelect = (brandId: string) => {
    navigate(`/brands/${brandId}`);
    setSearch('');
    setIsOpen(false);
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900">Find Your Brand</h2>
          <p className="mt-4 text-lg text-gray-600">
            Search for your appliance brand to get expert repair services
          </p>
        </div>

        <div className="max-w-xl mx-auto relative" ref={dropdownRef}>
          <div className="relative">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onFocus={() => setIsOpen(true)}
              placeholder="Enter brand name..."
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
          </div>

          {/* Dropdown */}
          {isOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-96 overflow-y-auto">
              {filteredBrands.length > 0 ? (
                <ul className="py-2">
                  {filteredBrands.map((brand) => (
                    <li key={brand.id}>
                      <button
                        onClick={() => handleBrandSelect(brand.id)}
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none"
                      >
                        <span className="font-medium text-gray-900">{brand.name}</span>
                        <span className="ml-2 text-sm text-gray-500">
                          All Appliance Services
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="px-4 py-3 text-sm text-gray-500">
                  No brands found
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}